(ns dre.modals.ds-stats.views
  (:require
   ["antd" :refer [Spin]]
   [clojure.string :as str]
   [dre.app.router :as router :refer [->route ->route-with-query-params]]
   [dre.components.inputs :refer [input-search]]
   [dre.components.table :refer [table]]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.modals.events :as-alias modals]
   [dre.modals.ds-stats.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.shared.interface.search.blunt :as blunt]
   [dre.shared.interface.search.pills :as pills]
   [dre.utils.bem :as bem]
   ["moment" :as moment]
   [goog.string :as gstring]
   [re-frame.core :as rf]))

(def component-name
  :ds-stats)

(defmulti sources-view :type)

(defn search-link
  [label source format]
  (let [query (gstring/format format (blunt/escape source))]
    [:a
     {:href (->route-with-query-params (->route :search) {:query query})}
     label]))

(defmethod sources-view :who-ictrp
  [{filter :filter data :who-ictrp state :state}]
  (let [filter (or filter "")
        is-filtered? (fn [e]
                       (or (str/blank? filter)
                           (and (not (str/blank? filter))
                                (str/includes? (str/lower-case (or (:label e) "")) (str/lower-case filter)))))
        f-data (filterv is-filtered? data)
        content (fn []
                  [:div
                   {:class component-name}
                   (if (= state :loading)
                     [:> Spin]
                     [table
                      {:columns [{:title [tr "Registry Name"]
                                  :render (fn [{:keys [:label :source]}]
                                            [search-link label source  "s(%s)"])
                                  :dataIndex :label
                                  :sorter :default}
                                 {:title [tr "Indexed Trials"]
                                  :render (fn [{:keys [:count :source]}]
                                            [search-link count source  "s(%s)"])
                                  :dataIndex :count
                                  :sorter :default}]
                       :dataSource f-data
                       :pagination {:defaultPageSize 10
                                    :hideOnSinglePage true}}])])]
    [modal-window
     {:title [:span
              {:class (bem/be component-name :modal-title)}
              [:span [tr "List of tracked WHO-ICTRP registries"]]
              [:span
               {:class (bem/be component-name :modal-title-extras)}
               [input-search
                {:placeholder @(rf/subscribe [::i18n/translate "Find..."])
                 :on-change (fn [e] (rf/dispatch [::events/set-filter (str (.-value (.-target e)))]))
                 :value filter}]]]
      :content content
      :submit? false}]))


(defmethod sources-view :congresses
  [{filter :filter data :congresses state :state}]
  (let [filter (or filter "")
        is-filtered? (fn [e]
                       (or (str/blank? filter)
                           (and (not (str/blank? filter))
                                (str/includes? (str/lower-case (or (:meeting e) "")) (str/lower-case filter)))))
        f-data (filterv is-filtered? data)
        content (fn []
                  [:div
                   {:class component-name}
                   (if (= state :loading)
                     [:> Spin]
                     [table
                      {:columns [{:title [tr "Meeting Name"]
                                  :render (fn [{:keys [:meeting]}]
                                            [search-link meeting meeting "f(%s).x(stscongress)"])
                                  :dataIndex :meeting
                                  :sorter :default}
                                 {:title [tr "Meeting Date"]
                                  :render (fn [{:keys [:date]}]
                                            (-> date (moment) (.format "MMM YYYY")))
                                  :dataIndex :date
                                  :sorter :default}
                                 {:title [tr "Indexed Abstracts"]
                                  :render (fn [{:keys [:count :meeting]}]
                                            [search-link count meeting "f(%s).x(stscongress)"])
                                  :dataIndex :count
                                  :sorter :default}]
                       :dataSource f-data
                       :pagination {:defaultPageSize 10
                                    :hideOnSinglePage true}}])])]
    [modal-window
     {:title [:span
              {:class (bem/be component-name :modal-title)}
              [:span [tr "List of tracked congresses"]]
              [:span
               {:class (bem/be component-name :modal-title-extras)}
               [input-search
                {:placeholder @(rf/subscribe [::i18n/translate "Find..."])
                 :on-change (fn [e] (rf/dispatch [::events/set-filter (str (.-value (.-target e)))]))
                 :value filter}]]]
      :content content
      :submit? false}]))

(defn date->yyyy-mm-dd
  [date]
  (when date
    (let [m (moment date)]
      (.format m "YYYY-MM-DD"))))

(defmethod sources-view :feeds
  [{filter :filter data :feeds state :state}]
  (let [admin? false
        filter (or filter "")
        is-filtered? (fn [e]
                       (or (str/blank? filter)
                           (and (not (str/blank? filter))
                                (str/includes? (str/lower-case (or (:title e) "")) (str/lower-case filter)))))
        show?
        #(and
          (is-filtered? %)
          (or (= 1 (:feed-status %))
              admin?))
        feeds (filterv show? data)
        content (fn []
                  [:div
                   {:class component-name}
                   (if (= state :loading)
                     [:> Spin]
                     [table
                      {:columns [{:title [tr "Title"]
                                  :render (fn [{:keys [:link :title :feed-id]}]
                                            (let [query [(pills/source-pill (str "feeds:" feed-id))]
                                                  query-str (blunt/print query)]
                                              [:a
                                               {:href (->route-with-query-params (->route :search) {:query query-str})}
                                               title]))
                                  :dataIndex :title
                                  :sorter :default}
                                 {:title [tr "Category"]
                                  :render (fn [{:keys [:category]}]
                                            category)
                                  :dataIndex :category
                                  :sorter :default}
                                 {:title [tr "Created"]
                                  :render (fn [{:keys [:_created]}]
                                            (date->yyyy-mm-dd _created))
                                  :dataIndex :_created
                                  :sorter :default}
                                 {:title [tr "Changed"]
                                  :render (fn [{:keys [:_modified]}]
                                            (date->yyyy-mm-dd _modified))
                                  :dataIndex :_modified
                                  :sorter :default}
                                 {:title [tr "Count"]
                                  :render (fn [{:keys [:_count :link :feed-id]}]
                                            (let [query [(pills/source-pill (str "feeds:" feed-id))]
                                                  query-str (blunt/print query)]
                                              [:a
                                               {:href (->route-with-query-params (->route :search) {:query query-str})}
                                               _count]))
                                  :dataIndex :_count
                                  :sorter :default}]
                       :dataSource feeds
                       :pagination {:defaultPageSize 10
                                    :hideOnSinglePage true}}])])]
    [modal-window
     {:title [:span
              {:class (bem/be component-name :modal-title)}
              [:span [tr "List of tracked feeds"]]
              [:span
               {:class (bem/be component-name :modal-title-extras)}
               [input-search
                {:placeholder @(rf/subscribe [::i18n/translate "Find..."])
                 :on-change (fn [e] (rf/dispatch [::events/set-filter (str (.-value (.-target e)))]))
                 :value filter}]]]
      :content content
      :submit? false}]))


(defn view
  []
  (when-let [state @(rf/subscribe [::modals/current-modal-data])]
    (sources-view state)))
